import { useCreateMachine } from 'fsm';
import { machine } from './machine';
import { useCurrentUser } from 'policy-lib';
import { SmartPropertiesContext } from './context';
// import { useCRMUpdateObject } from '../useCRMUpdateObject';

import { usePanelAlerts } from '../../../Panel/usePanelAlerts';
import { FILL_EMPTY_ONLY_OPTION_VAL } from '../../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const SmartPropertiesContextProvider = ({
  children,
  objectId,
  onClose,
  objectTypeId
}) => {
  const currentUser = useCurrentUser();
  const {
    onError,
    onSuccessProperties
  } = usePanelAlerts({
    objectTypeId: objectTypeId
  });
  const initialContext = {
    enrichmentType: 'company',
    errorId: null,
    fillOption: FILL_EMPTY_ONLY_OPTION_VAL,
    objectId,
    objectTypeId: objectTypeId,
    onClose,
    onError,
    onSuccess: onSuccessProperties,
    properties: [],
    selectedProperties: []
  };
  const smartPropertiesMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded
  });
  return /*#__PURE__*/_jsx(SmartPropertiesContext.Provider, {
    value: smartPropertiesMachine,
    children: children
  });
};